<!--
  A Card used to show messages together with a status icon, such as a success 
  message or an error message.
-->
<Panel flex items="start" justify="start" {mt} {mb} {m}>
  <Box w="4" align="center" pt="sm">
    <Icon name={icon} size="2.5" color={status} />
  </Box>
  <Panel align="left" ml="nm">
    <slot></slot>
  </Panel>
</Panel>

<script>
  import { onMount, tick } from 'svelte';
  import { Overlay, Panel, Box, Text, Icon, Button } from 'svelte-stylo';

  export let
    icon = null, 
    status = null,
    // allow setting margins for it
    mt = null,
    mb = null,
    ml = null,
    mr = null, 
    mx = null,
    my = null,
    m = null;

</script>